import { ArrowClockwise } from "@phosphor-icons/react";

/**
 * Renders a small spinner banner at the top of the page while the user is
 * pulling or the refresh is in flight. Hidden entirely on desktop (md+).
 */
export default function PullToRefreshIndicator({ distance, isRefreshing, threshold }) {
  const visible = distance > 4 || isRefreshing;
  if (!visible) return null;
  const progress = Math.min(1, distance / threshold);
  const rotate = progress * 360;

  return (
    <div
      className="md:hidden fixed inset-x-0 top-14 z-30 flex justify-center pointer-events-none"
      style={{ transform: `translateY(${Math.max(0, distance - 30)}px)`, transition: isRefreshing ? "transform 200ms" : "none" }}
      data-testid="pull-to-refresh-indicator"
    >
      <div className="mt-1 flex items-center gap-2 bg-white/95 backdrop-blur rounded-full shadow border border-slate-200 px-3 py-1.5 text-[11px] text-slate-700">
        <ArrowClockwise
          size={14}
          className={isRefreshing ? "animate-spin text-blue-600" : "text-slate-500"}
          style={{ transform: isRefreshing ? undefined : `rotate(${rotate}deg)` }}
          weight="bold"
        />
        <span>{isRefreshing ? "Refreshing…" : progress >= 1 ? "Release to refresh" : "Pull to refresh"}</span>
      </div>
    </div>
  );
}
